<div class="orbit-select-container">
  <button
    #selectButton
    type="button"
    class="orbit-select-trigger"
    [class.open]="isOpen()"
    [class.has-selection]="selectedOption() !== null"
    [disabled]="disabled()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
    [attr.aria-describedby]="name() + '-options'"
    [attr.data-testid]="testId()"
    (click)="toggleDropdown()"
    (keydown)="onKeyDown($event)">
    <span class="orbit-select-text">
      {{ displayText() }}
    </span>

    <orbit-fa-icon
      class="orbit-select-chevron"
      [class.rotated]="isOpen()"
      [iconName]="chevronIcon()" />
  </button>

  @if (isOpen()) {
    <div #dropdown class="orbit-select-dropdown" role="listbox">
      <ul
        #optionsList
        class="orbit-select-options"
        [attr.id]="name() + '-options'"
        [attr.aria-activedescendant]="
          focusedOptionIndex() >= 0 ? name() + '-option-' + focusedOptionIndex() : null
        ">
        @for (option of options(); track option.value; let i = $index) {
          @if (option.divider) {
            <li class="orbit-select-divider"></li>
          } @else {
            <li
              class="orbit-select-option"
              [class.focused]="isOptionFocused(i)"
              [class.selected]="isOptionSelected(option)"
              [class.disabled]="option.disabled"
              [attr.id]="name() + '-option-' + getEnabledOptionIndex(i)"
              [attr.aria-selected]="isOptionSelected(option)"
              [attr.aria-disabled]="option.disabled || null"
              (click)="onOptionClick(option, $event)"
              (mouseenter)="onOptionMouseEnter(i)"
              (keydown)="onOptionKeyDown(option, $event)">
              <span class="orbit-select-option-text">
                {{ option.label }}
              </span>

              @if (isOptionSelected(option)) {
                <orbit-fa-icon class="orbit-select-check" [iconName]="checkIcon" />
              }
            </li>
          }
        }
      </ul>
    </div>
  }
</div>
